const handleSearchedResults = {
    localStorageVarName: 'searchPredictions',
    category: 'categories',
    related: 'relatedContent',
    categoriesWrapper: '.categories-content-wrapper',
    categoriesTotalItems: '#categories-tab .total-items',
    relatedContentWrapper: '.related-content-wrapper',
    relatedContentTotalItems: '#related-tab .total-items',
    queryParameters:'resources[limit_scope]=each&resources[type]=product,page,collection,article&resources[options][fields]=body,product_type,tag,title,variants.sku,variants.title,vendor',
    data: {},
    term: '',
    categoriesExcluded: typeof collectionBlackList === 'string' ? collectionBlackList.split(",") : [],
    customSearchResults: typeof customSearchCategoryArray != 'undefined' ? customSearchCategoryArray : [],
    _init: function(){
        this._getResults();
    },
    _getResults: async function() {
        const term = this._getParams('q');
        if(!term) return;
        this.term = term;
        try {
            const request = await fetch(`/search/suggest.json?q=${term}&${this.queryParameters}`);
            if (!request.ok) throw new Error('Bad Request');
            const data = await request.json();
            this.data = data.resources.results;
        } catch (error) {
            console.log(error);
            return;
        }
        this._validateMatchTool();
        this._setCategories();
        this._setRelatedInfo();
    },
    _getParams:function(key) {
        const params = new Proxy(new URLSearchParams(window.location.search), {
            get: (searchParams, prop) => searchParams.get(prop),
        });
        return params[key];
    },
    _handleUpdate: function (tab, buildListFn) {
        const results = this.data;
        const term = this.term;
        const data = tab === this.category ? results.collections : [...results.pages, ...results.articles];
        const contentWrapper = tab === this.category ? $(this.categoriesWrapper) : $(this.relatedContentWrapper);
        const totalItemsWrapper = tab === this.category ? $(this.categoriesTotalItems) : $(this.relatedContentTotalItems);
        let numberOfResults = data.length;
        if(tab !== this.category && numberOfResults > 0) {
            data.forEach(item => {
                if(item.title.includes('A+') || item.title.includes('AA')) numberOfResults--;
            });
        }
        if(tab === this.category && numberOfResults > 0) {
            data.forEach(item => {
                if(this.categoriesExcluded.includes(item.id.toString())) numberOfResults--;
            });
        }

        
        if(tab === this.category && numberOfResults == 0) {
            let customResults = this._buildCustomResults(term);
            if (customResults.length > 0) {
                contentWrapper.empty();
                contentWrapper.append(customResults.html);
                numberOfResults = customResults.length;
            }
        } else {
            if(numberOfResults != 0){
                contentWrapper.empty();
                buildListFn(data, term, contentWrapper);
            }
        }
        this._setTotalItems(totalItemsWrapper,numberOfResults);
        
    },
    _setCategories: function() {
        this._handleUpdate(this.category, this._buildCategoriesList.bind(this));  
    },
    _setRelatedInfo: function() {
        this._handleUpdate(this.related, this._buildRelatedContentList.bind(this));  
    },
    _buildCategoriesList: function(data, term, contentWrapper) {
        let collectionExclusions = this.categoriesExcluded;
        const totalItems = data.length;
        let totalExclusions = 0;
        let htmlList = `<ul class="tw-category-list">`;
        data.forEach(element => {
            if(collectionExclusions.includes(element.id.toString())) {
                totalExclusions++;
            }else {
                htmlList+= `<li class="tw-category-item"><a class="tw-category-link"href=${element.url}>${element.title}</a></li>`;
            }
        });
        htmlList+= `</ul>`;
        if(totalItems !== totalExclusions) contentWrapper.append(htmlList);
    },
    _buildRelatedContentList: async function(data, term, contentWrapper) {
        let htmlList = ``;
        try {
            const request = await fetch(`/search/suggest?q=${term}&section_id=kanopi-predictive-search&${this.queryParameters}`);
            if (!request.ok) throw new Error('Section not found');
            const htmlText = await request.text();
            htmlList =  new DOMParser().parseFromString(htmlText, 'text/html').querySelector('#shopify-section-kanopi-predictive-search');
        } catch (error) {
            console.log(error);
            return;
        }
        contentWrapper.append(htmlList);
    },
    _setTotalItems: function(wrapper, totalItems) {
        if (wrapper.length === 0) return;
        wrapper.html(`(${totalItems})`);
    },
    _getRequestParam: function(param) {
        var res = null;
        try{
          var qs = decodeURIComponent(window.location.search.substring(1));//get everything after then '?' in URI
          var ar = qs.split('&');
          $.each(ar, function(a, b){
            var kv = b.split('=');
            if(param === kv[0]){
              res = kv[1];
              return false;//break loop
            }
          });
        }catch(e){}
        return res;
    },
    _validateMatchTool: function() {
        const regularTitle = $('.js-search-results-title');
        const matchTitle = $('.js-match-results-title');
        if(regularTitle.length === 0 || matchTitle.length === 0) return;
        if(this._getRequestParam('tool') === 'match') {
            matchTitle.removeClass('tw-hidden');
        }else {
            regularTitle.removeClass('tw-hidden');
        }
    },
    _buildCustomResults: function(term){
        let currentTerm = term.replace(" ", "_");
        let htmlList = '';
        if (this.customSearchResults && this.customSearchResults[currentTerm] ) {
            htmlList = `<ul class="tw-category-list">`;
            this.customSearchResults[currentTerm].forEach(element => {
                htmlList+= `<li class="tw-category-item"><a class="tw-category-link"href=${element.url}>${element.title}</a></li>`;
            });
            htmlList+= `</ul>`;
        }

        return {html: htmlList, length: this.customSearchResults[currentTerm]?.length ? this.customSearchResults[currentTerm]?.length : 0 };
    }
}
function slickProductsYouMightLikeComp() {
    var windowWidth = $(window).width();
    var slickSliderContainer=$('#no_search_results_products .grid-products');
    if (windowWidth <= 767) {
      if(slickSliderContainer.hasClass('slick-initialized')){
        slickSliderContainer.slick('unslick');
        }
        const cardWidth = 253;
        const paddingWrapper = 26;
        let calSlide = windowWidth / (cardWidth + paddingWrapper);
      slickSliderContainer.slick({
        infinite: false,
        dots: false,
        slidesToShow: calSlide,
        slidesToScroll: 1,
        variableWidth: false,
        arrows: true
      });
    } else{
      if(slickSliderContainer.hasClass('slick-initialized')){
      slickSliderContainer.slick('unslick');
      }
    }
  }


$( document ).on("ready", function() {
    handleSearchedResults._init();
    slickProductsYouMightLikeComp();
});

$(window).on('resize', function(){
slickProductsYouMightLikeComp();
});


//Toogle tab active status.
$('.js-tab-wrapper').on('click', function(e) {
    const tab = $(e.target).closest('.nav-item');
    if (tab.length === 0 || tab.hasClass('active')) return;
    const activeTab = $(this).find('.nav-item.active');
    activeTab.removeClass('active');
    tab.addClass('active');
})

$(document).on('ready', function() {
    waitForElm('#custom-search-results-totals').then(function (){
        CheckRelatedCustomResultTotal();
      })
});

const CheckRelatedCustomResultTotal = () => {
    let $customTotal = $('#custom-search-results-totals');
    let $relatedCounter = $('#related-tab .total-items');
    if ($customTotal?.length > 0 &&  $relatedCounter?.length > 0){
       $relatedCounter.html($customTotal.data("total"));
    }
}